import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const selectIsQaMode = rootStateBranchSelector('isQaMode');
